import { SxProps, Theme } from '@mui/material';

export const dialogTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
};

export const descriptionStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 2,
};

export const formAlertStyles: SxProps<Theme> = {
    mb: 2,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
};

/**
 * The list scrolls rather than the dialog growing: a clinic with a long price list would
 * otherwise push Save off the bottom of a laptop screen.
 */
export const choicesBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 360,
    overflowY: 'auto',
};

export const choiceContextStyles: SxProps<Theme> = {
    color: 'text.secondary',
    ml: 1,
};

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 3,
};
